import type { BrowseTrack } from '../browse';
import { track } from './events';

/**
 * The home page's "Browse raises" event (views/home.hbs #browse):
 * browse_link_clicked with the link's card and its address. It does
 * nothing else; every link is the server's, and the radar turns in CSS.
 */
export function browseSection(root: HTMLElement): void {
  root.addEventListener('click', (event) => {
    const link = (event.target as Element | null)?.closest<HTMLAnchorElement>(
      'a[data-browse-link]',
    );
    if (!link || !root.contains(link)) return;
    track('browse_link_clicked', {
      group: link.dataset.browseLink as BrowseTrack,
      target: link.getAttribute('href') ?? '',
    });
  });
}
